import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Footer from "../components/Footer";
import { CategoryDetails, ProductDetails } from "../lib/types";
import { earphones, headphones, speakers } from "../prod";
import { motion } from "framer-motion";

function CategoryView() {
  const categoryTitle = useParams();
  interface ProductDetails {
    id: number;
    title: string;
    name: string;
    price: number;
    img: string;
    new: boolean;
    category: string;
  }

  const [data, setData] = useState([...headphones, ...speakers, ...earphones]);
  const [desiredCategory, setDesiredCategory] = useState("");
  const navigate = useNavigate();
  function got(path: string) {
    navigate("/product/" + path);
    window.scrollTo(0, 0);
  }
  let categories: CategoryDetails[] = [
    {
      id: 1,
      title: "Headphones",
      img: require("../images/hps.png"),
    },
    {
      id: 2,
      title: "Speakers",
      img: require("../images/spks.png"),
    },
    {
      id: 3,
      title: "Earphones",
      img: require("../images/eps.png"),
    },
  ];

  const currentCategory = categories.filter((obj) => {
    return obj.title === categoryTitle.title;
  });

  const matchingProducts: ProductDetails[] = data.filter(
    (product): product is ProductDetails => product.category === desiredCategory
  );

  useEffect(() => {
    if (categoryTitle.title === "Headphones") {
      setData(headphones);
      setDesiredCategory("headphones");
    }
    if (categoryTitle.title === "Speakers") {
      setData(speakers);
      setDesiredCategory("speakers");
    }
    if (categoryTitle.title === "Earphones") {
      setData(earphones);
      setDesiredCategory("earphones");
    }
  });

  return (
    <>
      {currentCategory.map((category) => {
        return (
          <div className="text-black bg-white w-full flex flex-col justify-center gap-4 items-center">
            <div className="h-[8vh] bg-black w-full"></div>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1, ease: "easeOut" }}
              className="min-h-[92vh] w-11/12 md:w-10/12 py-2 flex flex-col gap-2"
            >
              <Link
                to="/"
                className="w-max text-xs font-bold tracking-wide text-black/60 hover:text-black"
              >
                GO BACK
              </Link>
              <p className="text-[3rem] font-bold mb-6 md:mb-8">
                {category.title}
              </p>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 pb-8 gap-4 md:gap-8">
                {matchingProducts?.length > 0 &&
                  matchingProducts.map((product) => {
                    return (
                      <div
                        key={product.id}
                        onClick={() => got(product.title)}
                        className="flex flex-col gap-2 items-center justify-between pb-2 w-[200px] bg-secondary/40 h-[250px] group flex-shrink-0 rounded-lg cursor-pointer"
                      >
                        <div className="bg-secondary size-[200px] overflow-hidden rounded-md rounded-b-xl grid place-items-center group-hover:shadow-xl shadow-primary transition-shadow duration-300">
                          <img src={product.img} alt="" className="w-[150px]" />
                        </div>
                        <p className="font-semibold w-[200px] wrap mt-1 text-center text-sm line-clamp-2 h-[42px] group-hover:text-primary cursor-pointer">
                          {product.name}
                        </p>
                      </div>
                    );
                  })}
              </div>
            </motion.div>
            <Footer />
          </div>
        );
      })}
    </>
  );
}

export default CategoryView;
